import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from '../../hooks/useTranslation';
import LanguageSwitcher from '../LanguageSwitcher';

const UserProfile = ({ onSubscriptionManagement }) => {
  const { currentUser, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const { t } = useTranslation();

  const handleLogout = async () => {
    try {
      await logout();
      setShowDropdown(false);
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  if (!currentUser) return null;

  return (
    <div className="user-profile">
      <button 
        className="user-profile-btn"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div className="user-avatar">
          {currentUser.photoURL ? (
            <img src={currentUser.photoURL} alt="Profile" />
          ) : (
            <span>{getInitials(currentUser.displayName)}</span>
          )}
        </div>
        <span className="user-name">{currentUser.displayName || t('user')}</span>
        <span className="dropdown-arrow">▼</span>
      </button>

      {showDropdown && (
        <div className="user-dropdown">
          <div className="user-info">
            <div className="user-info-header">
              <div className="user-info-avatar">
                {currentUser.photoURL ? (
                  <img src={currentUser.photoURL} alt="Profile" />
                ) : (
                  <span>{getInitials(currentUser.displayName)}</span>
                )}
              </div>
              <div className="user-info-text">
                <h4>{currentUser.displayName || t('user')}</h4>
                <p>{currentUser.email}</p>
              </div>
            </div>
          </div>
          
          <div className="user-dropdown-actions">
            <div className="language-switcher-section">
              <span className="action-label">{t('language')}</span>
              <LanguageSwitcher />
            </div>
            <button 
              className="dropdown-action-btn"
              onClick={() => {
                onSubscriptionManagement();
                setShowDropdown(false);
              }}
            >
              <span className="action-icon">💳</span>
              {t('subscription')}
            </button>
            <button 
              className="logout-btn"
              onClick={handleLogout}
            >
              <span className="logout-icon">🚪</span>
              {t('signOut')}
            </button>
          </div>
        </div>
      )}

      {showDropdown && (
        <div 
          className="dropdown-overlay"
          onClick={() => setShowDropdown(false)}
        />
      )}
    </div>
  );
};

export default UserProfile;